/**
 * The canoncial origin for any Cuttle website URL presented to a user.
 */
export const canonicalOrigin = "https://cuttle.xyz";

/**
 * The canonical origin to use when referring to Cuttle website assets, such as
 * fonts or SVGs.
 */
export const canonicalAssetsOrigin = "https://assets.cuttle.xyz";

/**
 * The origin used for API calls.
 */
export let apiOrigin = "https://api.cuttle.xyz";

/**
 * The origin to fetch assets from. The canonical origin should be replaced with
 * this one before fetching.
 */
export let assetsOrigin = "https://assets.cuttle.xyz";

/**
 * The origin to fetch auto-generated assets from.
 */
export let genOrigin = "https://gen.cuttle.xyz";

/**
 * The origin to use when linking to the blog.
 */
export let blogOrigin = "https://blog.cuttle.xyz";

/**
 * S3 bucket name for user uploads like fonts and images.
 */
export let publicBucketName = "cuttle-uploads";

// We've set up a mirror of the site at cuttlexyz.com for occassions when
// cuttle.xyz is blocked for people at the ISP level. We also mirror
// api.cuttle.xyz at api.cuttlexyz.com and need to use this api address when the
// user is using the cuttlexyz.com mirror.
if (window.location.hostname.includes("cuttlexyz.com")) {
  apiOrigin = "https://api.cuttlexyz.com";
  assetsOrigin = "https://assets.cuttlexyz.com";
  genOrigin = "https://gen.cuttlexyz.com";
  blogOrigin = "https://blog.cuttlexyz.com";
}

if (window.location.hostname.includes("localhost.cuttle.xyz")) {
  // Comment out these lines to use production API
  // apiOrigin = "https://localhost.cuttle.xyz:3000";
  // publicBucketName = "cuttle-uploads-dev";
}
